module.exports = "https://static.wmbcdn.com/uniweb/images/b3124162c29cd2d446441e614213e0af.svg";